import useSyncAuthIdentity from '../hooks/useSyncAuthIdentity.hook';

const AuthIdentitySync = () => {
  useSyncAuthIdentity();

  return null;
};

export default AuthIdentitySync;
